<template>
  <v-container fluid>
    <v-card class="elevation-3 pa-2">
      <v-card-title>
        <v-icon left color="green darken-2">mdi-microsoft-excel</v-icon>
        Relatório de Assessores por Zona Geográfica
      </v-card-title>
      <v-card-subtitle>
        Exporta os assessores e suas áreas de atuação em Excel. Filtrando por uma
        zona geográfica (Capital) ou município (Interior), o assessor aparece na
        área filtrada e as demais áreas dele vão nas colunas seguintes. Sem filtro
        de área, o relatório traz todos os assessores com todas as suas zonas.
      </v-card-subtitle>

      <v-card-text>
        <v-row>
          <v-col cols="12" sm="4">
            <v-select
              v-model="select_equipe"
              :items="candidatos"
              item-value="idcandidato"
              item-text="nome_completo"
              label="Equipe"
              prepend-inner-icon="mdi-account-group"
              outlined
              dense
              hide-details
            ></v-select>
          </v-col>

          <v-col cols="12" sm="4">
            <v-select
              v-model="select_zona"
              :items="zonas_geograficas"
              item-value="id"
              item-text="nome"
              label="Zona Geográfica (Capital)"
              prepend-inner-icon="mdi-compass-outline"
              outlined
              dense
              hide-details
            ></v-select>
          </v-col>

          <v-col cols="12" sm="4">
            <v-autocomplete
              v-model="select_municipio"
              :items="municipios"
              item-value="id"
              item-text="nome"
              label="Município (Interior — AM)"
              prepend-inner-icon="mdi-city-variant-outline"
              outlined
              dense
              hide-details
            ></v-autocomplete>
          </v-col>
        </v-row>

        <v-row v-if="select_zona > 0 || select_municipio > 0">
          <v-col cols="12" class="pt-0">
            <span class="caption grey--text">
              Zona geográfica e município são filtros exclusivos — selecionar um
              limpa o outro.
            </span>
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="green darken-1" dark depressed @click="exportar">
          <v-icon left>mdi-microsoft-excel</v-icon>
          Exportar Excel
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>
import AclAPI from "./../../api/acl";

export default {
  name: "RelatorioAssessoresZona",
  data: () => ({
    candidatos: [{ idcandidato: 0, nome_completo: "Todas as equipes" }],
    zonas_geograficas: [{ id: 0, nome: "Todas as zonas" }],
    municipios: [{ id: 0, nome: "Todos os municípios" }],
    select_equipe: 0,
    select_zona: 0,
    select_municipio: 0,
  }),
  watch: {
    // Um assessor de capital nunca tem municipio (e vice-versa): manter os dois
    // filtros ativos resultaria sempre em lista vazia.
    select_zona(valor) {
      if (valor > 0) this.select_municipio = 0;
    },
    select_municipio(valor) {
      if (valor > 0) this.select_zona = 0;
    },
  },
  mounted() {
    this.carregarFiltros();
  },
  methods: {
    carregarFiltros() {
      const headers = this.Helpers.iniciarRequisicao();

      AclAPI.getCandidatos(headers)
        .then((response) => {
          localStorage.setItem("token", response.data.token);
          this.candidatos = [
            { idcandidato: 0, nome_completo: "Todas as equipes" },
            ...response.data.candidatos,
          ];
        })
        .catch(() => {});

      AclAPI.getZonasGeograficas(headers)
        .then((response) => {
          localStorage.setItem("token", response.data.token);
          this.zonas_geograficas = [
            { id: 0, nome: "Todas as zonas" },
            ...response.data.zonas_geograficas,
          ];
        })
        .catch(() => {});

      AclAPI.getMunicipios(headers)
        .then((response) => {
          localStorage.setItem("token", response.data.token);
          this.municipios = [
            { id: 0, nome: "Todos os municípios" },
            ...response.data.municipios,
          ];
        })
        .catch(() => {});
    },

    exportar() {
      const equipe = this.select_equipe || 0;
      const zona = this.select_zona || 0;
      const municipio = this.select_municipio || 0;
      const idCd = localStorage.getItem("id");

      const url =
        "relatorio_assessores_zona?equipe=" +
        equipe +
        "&zona_geografica=" +
        zona +
        "&municipio=" +
        municipio +
        "&id_cd=" +
        idCd;
      window.open(process.env.VUE_APP_URL_BASE + "/api/" + url, "_blank");
    },
  },
};
</script>
